module.exports = __webpack_public_path__ + "img/partner_kj.9f78f592.jpg";